
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 32.88"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M43 32.88H5a5 5 0 01-5-5V5a5 5 0 015-5h38a5 5 0 015 5v22.88a5 5 0 01-5 5zM5 2a3 3 0 00-3 3v22.88a3 3 0 003 3h38a3 3 0 003-3V5a3 3 0 00-3-3z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M41 18.5H25a1 1 0 010-2h16a1 1 0 010 2zM41 23.32H25a1 1 0 010-2h16a1 1 0 010 2zM41 13.68H25a1 1 0 010-2h16a1 1 0 010 2zM10.29 15.33l.08.05a6 6 0 00.65.37 4.68 4.68 0 00.48.18 4.5 4.5 0 001.3.19 4.41 4.41 0 002.1-.52c.15-.08.29-.17.44-.27a4.36 4.36 0 001-6.07 4.36 4.36 0 10-6.08 6.07zM15.6 17.12l-.32-.12a3.83 3.83 0 01-2.46 1 3.84 3.84 0 01-2.47-1l-.32.13a7.45 7.45 0 00-4.6 6.37 1.84 1.84 0 001.28 1.68 2.74 2.74 0 00.28.07 2.21 2.21 0 00.37 0h10.92a2.46 2.46 0 00.37 0 2.07 2.07 0 00.32-.09 1.79 1.79 0 001.23-1.67 7.45 7.45 0 00-4.6-6.37z"}})])])])
          )
        }
      }
    